import {
  ReadUserReferralsRequestDto,
  ReadUserReferralsResponseDto,
  UserIntroducerRequestDto,
  UserIntroducerResponseDto,
} from '@sparling/financial-common'
import axios, { AxiosRequestConfig } from 'axios'
import { isNil } from 'lodash'

export const introducerRequest = async (
  { token, ...params }: UserIntroducerRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<UserIntroducerResponseDto> => {
  const response = await window.fetch(`${process.env.REACT_APP_REST_API_URL}/user/introducer-request`, {
    ...options,
    body: JSON.stringify(params),
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
  return response.json()
}

export const fetchUserReferrals = async (
  { token, introducerIdSf, ...params }: ReadUserReferralsRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<ReadUserReferralsResponseDto> => {
  const response = await axios.get(`${process.env.REACT_APP_REST_API_URL}/web/user-referrals/${introducerIdSf}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
    params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
  })

  return response.data
}
